define([
  "jquery",
  "underscore",
  "marionette",
  "google_analytics",
  "forms/deposit/deposit_sticpay_pg_form",
  "behaviors/form_errors_behavior",
  "backbone.syphon",
], function (
  $,
  _,
  Marionette,
  GoogleAnalytics,
  SticpayPgForm,
  FormErrorsBehavior
) {
  return Marionette.View.extend({
    el: "#content_layout",
    behaviors: {
      formErrors: {
        behaviorClass: FormErrorsBehavior,
      },
    },

    ui: {
      amount: "#amount",

      deposit: "#deposit_btn",
      hold_on_overlay: "#holdon-overlay",
    },

    events: {
      "keyup @ui.amount": "requestKrwToUsd",
      "click @ui.deposit": "deposit",
    },

    initialize: function () {
      GoogleAnalytics.sendGaPageviewEvent(
        GoogleAnalytics.googleAnalyticsUrls.sticpay_open_amount
      );
    },

    deposit: function (e) {
      e.preventDefault();

      this.triggerMethod("hide:errors");

      var formData = Backbone.Syphon.serialize(this.$("#form_submit")[0]);
      var form = new SticpayPgForm();
      form.set(formData);

      var errors = form.validate();

      var that = this;

      if (_.size(errors) < 1) {
        $(that.ui.hold_on_overlay).show();

        form.validateWithServer({
          type: "POST",
          success: function (model, res) {
            that.$("#form_submit").submit();

            GoogleAnalytics.sendGaPageviewEvent(
              GoogleAnalytics.googleAnalyticsUrls.sticpay_pageout
            );
          },

          error: function (model, error) {
            $(that.ui.hold_on_overlay).hide();
            that.triggerMethod("show:errors", error.responseJSON);
          },
        });
      } else {
        this.triggerMethod("show:errors", errors);
      }
    },

    requestKrwToUsd: function (e) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        const krw = $("#amount").val();
        if (isNaN(krw) || krw === "" || !krw) {
          $("#expected_amount").val("-");
          return;
        }

        $("#error_amount").text("");
        $("#expected_amount").val("-");

        const min_amount = window.min_amount;
        const max_amount = window.max_amount;
        const is_simple = window.is_simple;
        const deposit_sum_amount = window.deposit_sum_amount;
        const deposit_limit_amount = window.deposit_limit_amount;

        // 1. check min amount for both accounts
        if (krw < min_amount) {
          $("#expected_amount").text("-");
          $("#deposit_btn").attr("disabled", true);
          $("#error_amount").text(
            window.translations.error_krbank_min_deposit_amount
          );
          return;
        }

        // 2. check max amount for normal account
        if (!is_simple && krw > max_amount) {
          $("#expected_amount").text("-");
          $("#deposit_btn").attr("disabled", true);
          $("#error_amount").text(
            window.translations.error_krbank_max_deposit_amount
          );
          return;
        }

        $.ajax({
          url: `/rest_deposit/calculate_deposit_rated_amount?krw=${krw}`,
          type: "GET",
          success: function (data) {
            // 3. check max amount for simple account
            if (
              is_simple &&
              data.deposit_rated_amount > deposit_limit_amount - deposit_sum_amount
            ) {
              $("#expected_amount").text("-");
              $("#deposit_btn").attr("disabled", true);
              $("#error_amount").text(
                data.error_simple_account_deposit_limit
              );
              return;
            }

            // finally return expected amount
            $("#expected_amount").text("$" + data.deposit_rated_amount_format);
            $("#deposit_btn").attr("disabled", false);
            return;
          },
        });
      }, 300);
    },
  });
});
